


document.addEventListener("DOMContentLoaded", function() {
    const buttons = document.querySelectorAll('.custom_blog_tab_button');
    const containers = document.querySelectorAll('.custom_blog_container');

    buttons.forEach(button => {
        button.addEventListener('click', function() {
            // console.log(this.textContent.trim());
            // console.log(this);
            // const selectedCategory = this.textContent.trim().toLowerCase();   
            // const selectedCategory = this.id; 
            handleTabClick(this);
        });
    });

    function handleTabClick(category) {
        
        containers.forEach(container => {
            container.style.display = 'none';
        });

        if (category === '') {
            containers.forEach(container => {
                container.style.display = 'block';
            });
        }
         else {
            const activeContainer = document.querySelector(`.custom_blog_container.custom_tab_${category.id}`);
            if (activeContainer) {
                activeContainer.style.display = 'block';
            }
        }

        buttons.forEach(btn => btn.classList.remove('active'));
        category.classList.add('active');
    }

    $('.feature_prd_slider').slick({
        dots: true,
        infinite: false,
        arrows:true,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow:'<button type="button" data-role="none" class="slick-prev">Previous</button>',
        nextArrow:'<button type="button" data-role="none" class="slick-next">Next</button>',
      });

      document.querySelectorAll('.shopify-payment-button__button').forEach(function(element) {
        element.innerText = 'Book your consultation';
      });

    //   ======= custom add to cart ==============
    document.querySelectorAll(".ctm_booK_Now_btn")?.forEach(function (currBtn) {
        currBtn.addEventListener("click",function () {
            this.closest(".ctm_payment_btn")?.querySelector(".shopify-payment-button__button").click();
        })
    })

    document.addEventListener('click', function (e) {
        const gridCtrl = e.target.closest('.cus-collection-grid-control');
        if (!gridCtrl) return;

        const isSingle = e.target.closest('.cus-collection-single');
        const isDouble = e.target.closest('.cus-collection-double');
        const gridBox = document.querySelector('.cus-grid-handling');

        if (isSingle || isDouble) {
            gridCtrl.querySelector('.active-grid')?.classList.remove('active-grid');
            (isSingle || isDouble).classList.add('active-grid');

            if (gridBox) {
            gridBox.classList.toggle('single', !!isSingle);
            }
        }
    });


    
});


document.addEventListener('DOMContentLoaded', function () {
  document.addEventListener('click', function (e) {
    const clickedBtn = e.target.closest('.cus-avail-toggle-option');
    if (!clickedBtn) return;

    document.querySelectorAll('.cus-avail-toggle-option').forEach(b => b.classList.remove('active'));
    clickedBtn.classList.add('active');

    const selected = clickedBtn.dataset.value;
    const label = document.querySelector('label.cus-avail-label');
    const checkbox = label ? label.querySelector('input[type="checkbox"]') : null;
    if (!label || !checkbox) return;

    if (selected === 'hide') {
      checkbox.disabled = false;
      label.click();
    } else if (selected === 'show') {
      if (checkbox.checked) label.click();
      checkbox.disabled = true;
    }
  });

  // Handle active state on page load based on URL
  const urlParams = new URLSearchParams(window.location.search);
  const isAvailabilitySet = urlParams.getAll('filter.v.availability').includes('1');

  const checkbox = document.querySelector('label.cus-avail-label input[type="checkbox"]');
  const label = document.querySelector('label.cus-avail-label');

  const showBtn = document.querySelector('.cus-avail-toggle-option[data-value="show"]');
  const hideBtn = document.querySelector('.cus-avail-toggle-option[data-value="hide"]');

  if (isAvailabilitySet) {
    hideBtn?.classList.add('active');
    if (checkbox && label) {
      checkbox.disabled = false;
      if (!checkbox.checked) label.click(); // Apply filter if not already checked
    }
  } else {
    showBtn?.classList.add('active');
    if (checkbox) checkbox.disabled = true;
  }
});

document.addEventListener('DOMContentLoaded', function () {
  document.addEventListener('click', function (e) {
    const clickedBtn = e.target.closest('.cus-avail-toggle-option-mob');
    if (!clickedBtn) return;

    document.querySelectorAll('.cus-avail-toggle-option-mob').forEach(b => b.classList.remove('active'));
    clickedBtn.classList.add('active');

    const selected = clickedBtn.dataset.value;
    const label = document.querySelector('label.cus-avail-label-mob');
    const checkbox = label ? label.querySelector('input[type="checkbox"]') : null;
    if (!label || !checkbox) return;

    if (selected === 'hide') {
      checkbox.disabled = false;
      label.click();
    } else if (selected === 'show') {
      if (checkbox.checked) label.click();
      checkbox.disabled = true;
    }
  });

  // Handle active state on page load based on URL
  const urlParams = new URLSearchParams(window.location.search);
  const isAvailabilitySet = urlParams.getAll('filter.v.availability').includes('1');

  const checkbox = document.querySelector('label.cus-avail-label-mob input[type="checkbox"]');
  const label = document.querySelector('label.cus-avail-label-mob');

  const showBtn = document.querySelector('.cus-avail-toggle-option-mob[data-value="show"]');
  const hideBtn = document.querySelector('.cus-avail-toggle-option-mob[data-value="hide"]');

  if (isAvailabilitySet) {
    hideBtn?.classList.add('active');
    if (checkbox && label) {
      checkbox.disabled = false;
      if (!checkbox.checked) label.click(); // Apply filter if not already checked
    }
  } else {
    showBtn?.classList.add('active');
    if (checkbox) checkbox.disabled = true;
  }
});

function filterToggleBtn() {
  setTimeout(() => {
    const isChecked = document.querySelector('.cus-avail-label input').checked;
    document.querySelectorAll('.cus-avail-toggle-button button').forEach(button => {
      button.classList.toggle('active', (button.dataset.value === 'show' && !isChecked) || (button.dataset.value === 'hide' && isChecked));
    });

    const isChecked1 = document.querySelector('.cus-avail-label-mob input').checked;
    document.querySelectorAll('.cus-avail-toggle-button-mob button').forEach(button => {
      button.classList.toggle('active', (button.dataset.value === 'show' && !isChecked1) || (button.dataset.value === 'hide' && isChecked1));
    });
  }, 2000);
}


